/* eslint-disable jsx-a11y/aria-role */
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLES } from '../../../constants/general.constants';

const ROUTER_ROLES = ['admin', 'super'];

export const SuperAdminRoute = ({ component: Component, path, exact = false, fallback }) => {
	const user = useSelector((state) => state.user.value);
	const status = useSelector((state) => state.user.status);
	const userHasRequiredRole = user?.role != null ? ROUTER_ROLES.includes(user?.role) : false;

	const render = (props) => {
		// Create fallback url
		let fallbackUrl = null;
		if (fallback) {
			fallbackUrl = fallback;
			if (props.match.params && props.match.params.id) {
				fallbackUrl = fallbackUrl.replace(':id', props.match.params.id);
			}
		}

		// Return or redirect
		if (user && userHasRequiredRole) {
			return <Component {...props} role={ROLES.ADMIN} />;
		}
		if (fallbackUrl != null) {
			return (
				<Redirect
					to={{
						pathname: fallbackUrl,
					}}
				/>
			);
		}
		return (
			<Redirect
				to={{
					pathname: '/insufficient-permissions',
				}}
			/>
		);
	};

	if (status === 'idle') {
		return null;
	}

	return <Route exact={exact} path={path} render={render} />;
};

SuperAdminRoute.propTypes = {
	component: PropTypes.func.isRequired,
	path: PropTypes.string,
	exact: PropTypes.bool,
	fallback: PropTypes.string,
	match: PropTypes.object,
};
